module.exports = __webpack_public_path__ + "static/media/Logo.26c04479.png";